<template>
  <div>
    <h1>Passwort vergessen</h1>

    <el-card>
      <el-alert
        :closable="false"
        show-icon
        title="Die Rücksetzung des Passworts wurde erfolgreich gestartet."
        type="success"
      />

      <el-alert
        :closable="false"
        show-icon
        title="Sie erhalten eine E-Mail-Benachrichtigung mit weiteren Informationen."
        type="warning"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'VPasswordPending',

  metaInfo: {
    title: 'Passwort vergessen'
  }
}
</script>
